(function () {
    'use strict';

    angular
            .module('imnApp')
            .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
                .state('alarms', {
                    parent: 'app.private',
                    url: '/alarms',
                    data: {
                        pageTitle: 'alarm.title'
                    },
                    params: {
                        id: {
                            value: null,
                            array: true,
                            squash: true
                        },
                        type: {
                            value: null
                        },
                        hiddenParam: 'YES'
                    },
                    views: {
                        'content@app.private': {
                            templateUrl: 'app/components/alarm/alarm.html',
                            controller: 'AlarmController',
                            controllerAs: 'vmAlarm'
                        },
                        'filter@alarms': {
                            templateUrl: 'app/components/alarm/alarm-filter.html',
                            controller: 'AlarmFilterController',
                            controllerAs: 'vmAlarmFilter'
                        },
                        'list@alarms': {
                            templateUrl: 'app/components/alarm/alarm-list.html',
                            controller: 'AlarmListController',
                            controllerAs: 'vmAlarmList'
                        },
                        'settings@alarms': {
                            templateUrl: 'app/components/alarm/alarm-settings.html',
                            controller: 'AlarmSettingsController',
                            controllerAs: 'vmAlarmSettings'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('global');
                                $translatePartialLoader.addPart('alarm');
                                $translatePartialLoader.addPart('alarm-modal');
                                return $translate.refresh();
                            }]
                    }
                })
    }

})();
